import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import authService from "../services/authService";
import { Button, Spinner } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

const Captcha = forwardRef(({ onCaptchaChange }, ref) => {
    const [captcha, setCaptcha] = useState({ captchaKey: "", captchaImage: null }); // Initialize image as null
    const [captchaValue, setCaptchaValue] = useState("");
    const [loading, setLoading] = useState(false);

    // Expose the refreshCaptcha method to parent components
    useImperativeHandle(ref, () => ({
        refreshCaptcha: fetchCaptcha
    }));

    useEffect(() => {
        fetchCaptcha();
    }, []);

    const fetchCaptcha = async () => {
        if (loading) return;
        setLoading(true);  
        try {
            const response = await authService.getCaptcha();
            setCaptcha({
                captchaKey: response.captchaKey,
                captchaImage: response.captchaImage || null // Ensure null if no image
            });
            setCaptchaValue("");
            onCaptchaChange(response.captchaKey, "");
        } catch (err) {
            console.error("Failed to load CAPTCHA:", err);
            // Reset captcha state on error
            setCaptcha({ captchaKey: "", captchaImage: null });
        }
        setLoading(false);
    };

    const handleCaptchaInputChange = (e) => {
        setCaptchaValue(e.target.value);
        onCaptchaChange(captcha.captchaKey, e.target.value);
    };

    return (
        <>
            <div className="captcha-wrapper">
                {captcha.captchaImage && (
                    <img 
                        src={captcha.captchaImage} 
                        alt="CAPTCHA"
                        className="captcha-image"
                        onError={() => {
                            console.error("Failed to load CAPTCHA image");
                            setCaptcha(prev => ({ ...prev, captchaImage: null }));
                        }}
                    />
                )}
                
                <Button 
                    variant="link" 
                    onClick={fetchCaptcha} 
                    disabled={loading}
                    title="Refresh CAPTCHA"
                    aria-label="Refresh CAPTCHA"
                    className="captcha-refresh"
                >
                    {loading ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        <i className="bi bi-arrow-clockwise"></i>
                    )}
                </Button>
            </div>
            
            <input
                type="text"
                className="form-control glass-input"
                placeholder="Enter CAPTCHA"
                value={captchaValue}
                onChange={handleCaptchaInputChange}
                required
                aria-label="CAPTCHA input"
            />
        </>
    );
});

export default Captcha;